import { DateRangePresetFilterRequest } from '../../shared/interfaces/DateRangePresetFilterRequest';
import { apiService } from '../../shared/services/apiService';
import { ScanIqCustomerAnalyticsInfo } from '../interfaces/ScanIqCustomerAnalyticsInfo';
import { ScanIqCustomerSuccessInfo } from '../interfaces/ScanIqCustomerSuccessInfo';

export const scanIqHomeService = {
  async getCustomerSuccess(entityId: number): Promise<ScanIqCustomerSuccessInfo> {
    const resp = await apiService.get<ScanIqCustomerSuccessInfo>(
      `/api/entity/${entityId}/scan-iq/home-page/customer-success`,
    );

    return resp.data;
  },

  async getCustomerAnalytics(
    body: DateRangePresetFilterRequest,
  ): Promise<ScanIqCustomerAnalyticsInfo> {
    const resp = await apiService.post<ScanIqCustomerAnalyticsInfo>(
      `/api/scan-iq/home-page/customer-analytics`,
      body,
    );

    return resp.data;
  },
};
